import type { Organization } from './organization';
import type { OrganizationUser } from './organizationUser';
import type { RoleProfile } from './roleProfile';
import type { User } from './user';

export enum FileDocumentObjectTypes {
  USER = 'USER',
  ACCOUNT = 'ACCOUNT',
  SUBACCOUNT = 'SUBACCOUNT',
  CLIENTGROUP = 'CLIENTGROUP',
  ORGANIZATION = 'ORGANIZATION',
  GOAL = 'GOAL',
  SCHEDULED_TRANSFER = 'SCHEDULED_TRANSFER',
  BULK_IMPORT = 'BULK_IMPORT',
  ORGANIZATION_USER = 'ORGANIZATION_USER',
  FORM_DEFINITION = 'FORM_DEFINITION',
  FORM_COMPLETION_SIGNED = 'FORM_COMPLETION_SIGNED',
  FORM_COMPLETION_UNSIGNED = 'FORM_COMPLETION_UNSIGNED',
}

export enum FileDocumentTypes {
  FORM = 'FORM',
  INVOICE = 'INVOICE',
  NOTES = 'NOTES',
  OTHER = 'OTHER',
  STATEMENT = 'STATEMENT',
  BANKING = 'BANKING',
  LOGO = 'LOGO',
  BULK_IMPORT = 'BULK_IMPORT',
  ID_VERIFICATION = 'ID_VERIFICATION',
  WORKFLOW = 'WORKFLOW',
  ERROR_PAGE_BACKGROUND_IMAGE = 'ERROR_PAGE_BACKGROUND_IMAGE',
  TEMPLATE = 'TEMPLATE',
  ARTICLE = 'ARTICLE',
  AVATAR = 'AVATAR',
  CLIENT_REPORT = 'CLIENT_REPORT',
  CLIENT_REPORT_TEMPLATE = 'CLIENT_REPORT_TEMPLATE',
}

export enum FileDocumentPermissionTypes {
  ORGANIZATIONAL = 'ORGANIZATIONAL',
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export type FileDocument = {
  id: string;
  name: string;
  fileName: string;
  objectType: FileDocumentObjectTypes;
  mediaType: string;
  type: FileDocumentTypes;
  permissionType: FileDocumentPermissionTypes;
  requestId?: string;
  uploadedAt: Date;
  createdAt: string;
  updatedAt: string;
  uploadUrl?: string;
  s3Key: string;
  sharedCustodian?: boolean;
  sharedClient?: boolean;
  signed?: boolean;
  objectId: string;
  sourceId?: string;
  creator?: OrganizationUser;
  creatorOrganization?: Organization;
  organization?: Organization;
  user?: User;
  sourceType?: string;
  requestIpAddress?: string;
  sharedWithRoleProfiles?: RoleProfile[];
};
